export default function() {
  'ngInject';
  return function(bytes, precision) {
    const units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    // validate 'bytes'
    if (isNaN(parseFloat(bytes))) {
      return '-';
    }
    if (bytes < 1) {
      return '0 B';
    }

    // validate 'precision'
    if (isNaN(precision)) {
      precision = 1;
    }

    const unitIndex = Math.floor(Math.log(bytes) / Math.log(1000)),
      value = bytes / Math.pow(1000, unitIndex);

    return value.toFixed(precision) + ' ' + units[unitIndex];
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/FileSize.js